import { AfterViewInit, Directive, DOCUMENT, ElementRef, inject, Input, OnChanges, SimpleChanges, ViewContainerRef } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { PlatformService } from '@rma/public/generic/util/environment';
import { BackToMapComponent } from './back-to-map.component';

@UntilDestroy()
@Directive({
  selector: '[rmaBackToMap]',
  standalone: true,
})
export class BackToMapDirective implements OnChanges, AfterViewInit {
  private readonly document = inject<Document>(DOCUMENT);
  private readonly elementRef = inject(ElementRef);
  private readonly platformService = inject(PlatformService);
  private readonly vcr = inject(ViewContainerRef);

  @Input()
  selectedItemId: string | null | undefined;

  ngAfterViewInit(): void {
    if (this.platformService.isPlatformBrowser) {
      this.isInView();
      this.isParentInView();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { selectedItemId } = changes;

    if (selectedItemId && this.selectedItemId) {
      const selectedElement = this.document.getElementById(this.selectedItemId);

      if (selectedElement) {
        selectedElement.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  private isInView(): void {
    const elToObserve = this.vcr.element.nativeElement;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        this.renderContents(!entry.isIntersecting);
      },
      { threshold: 0.5 },
    );

    observer.observe(elToObserve);
  }

  private isParentInView(): void {
    const elToObserve = this.vcr.element.nativeElement;
    const parent = elToObserve.parentNode.parentNode;

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      this.renderContents(entry.isIntersecting);
    });

    observer.observe(parent);
  }

  private renderContents(show: boolean) {
    this.vcr.clear();

    if (show && this.selectedItemId) {
      const component = this.vcr.createComponent<BackToMapComponent>(BackToMapComponent);
      component.setInput('mapElement', this.elementRef);
      component.changeDetectorRef.detectChanges();
    }
  }
}
